export function sanitizePath(name: string): string {
    return name ? name.replace(/[.']/g, "").replace(/ /g, "-").toLowerCase() : ""
}
